// eslint-disable-next-line import/no-cycle
import {

    SETTING_CREATE_MEMBERSHIP_CATEGORY,
    SETTING_CREATE_MEMBERSHIP_CATEGORY_SUCCESS,
    SETTING_UPDATE_MEMBERSHIP_CATEGORY,
    SETTING_UPDATE_MEMBERSHIP_CATEGORY_SUCCESS,
    SETTING_LOAD_MEMBERSHIP_CATEGORY,
    SETTING_LOAD_MEMBERSHIP_CATEGORY_SUCCESS,
    SETTING_DELETE_MEMBERSHIP_CATEGORY,
    SETTING_DELETE_MEMBERSHIP_CATEGORY_SUCCESS,

    SETTING_LOAD_MEMBERSHIP,
    SETTING_LOAD_MEMBERSHIP_SUCCESS,
    SETTING_CREATE_MEMBERSHIP,
    SETTING_CREATE_MEMBERSHIP_SUCCESS,
    SETTING_UPDATE_MEMBERSHIP,
    SETTING_UPDATE_MEMBERSHIP_SUCCESS,
    SETTING_DELETE_MEMBERSHIP,
    SETTING_DELETE_MEMBERSHIP_SUCCESS,
    // SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER,
    // SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER_SUCCESS,

    // SETTING_UPDATE_MEMBERSHIP_STATUS,
    // SETTING_UPDATE_MEMBERSHIP_STATUS_SUCCESS,

} from '../../actions';

// // -------------------- getMembershipCategory --------------------- //
export const getMembershipCategory = (data, token) => ({
    type: SETTING_LOAD_MEMBERSHIP_CATEGORY,
    payload: data,
    token
});
export const getMembershipCategorySuccess = (data, list) => ({
    type: SETTING_LOAD_MEMBERSHIP_CATEGORY_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createMembershipCategory --------------------- //
export const addMembershipCategory = (data, token) => ({
    type: SETTING_CREATE_MEMBERSHIP_CATEGORY,
    payload: data,
    token
});
export const addMembershipCategorySuccess = () => ({
    type: SETTING_CREATE_MEMBERSHIP_CATEGORY_SUCCESS,
});

// // -------------------- updateMembershipCategory --------------------- //
export const updateMembershipCategory = (data, token) => ({
    type: SETTING_UPDATE_MEMBERSHIP_CATEGORY,
    payload: data,
    token
});
export const updateMembershipCategorySuccess = () => ({
    type: SETTING_UPDATE_MEMBERSHIP_CATEGORY_SUCCESS,
});

// // -------------------- deleteMembershipCategory --------------------- //
export const deleteMembershipCategory = (data, token) => ({
    type: SETTING_DELETE_MEMBERSHIP_CATEGORY,
    payload: data,
    token
});
export const deleteMembershipCategorySuccess = () => ({
    type: SETTING_DELETE_MEMBERSHIP_CATEGORY_SUCCESS,
});

// // -------------------- getMembership --------------------- //
export const getMembership = (data, token) => ({
    type: SETTING_LOAD_MEMBERSHIP,
    payload: data,
    token
});
export const getMembershipSuccess = (data, list) => ({
    type: SETTING_LOAD_MEMBERSHIP_SUCCESS,
    payload: data,
    payloadlist: list
});

// // -------------------- createMembership --------------------- //
export const createMembership = (data, token) => ({
    type: SETTING_CREATE_MEMBERSHIP,
    payload: data,
    token
});
export const createMembershipSuccess = () => ({
    type: SETTING_CREATE_MEMBERSHIP_SUCCESS,
});

// // -------------------- updateMembership --------------------- //
export const updateMembership = (data, token) => ({
    type: SETTING_UPDATE_MEMBERSHIP,
    payload: data,
    token
});
export const updateMembershipSuccess = () => ({
    type: SETTING_UPDATE_MEMBERSHIP_SUCCESS,
});

// // -------------------- deleteMembership --------------------- //
export const deleteMembership = (data, token) => ({
    type: SETTING_DELETE_MEMBERSHIP,
    payload: data,
    token
});
export const deleteMembershipSuccess = () => ({
    type: SETTING_DELETE_MEMBERSHIP_SUCCESS,
});
// // // -------------------- getAllCustomer --------------------- //
// export const getAllMembershipCustomer = (data, token) => ({
//     type: SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER,
//     payload: data,
//     token
// });
// export const getAllMembershipCustomerSuccess = (data, list) => ({
//     type: SETTING_LOAD_ALL_MEMBERSHIP_CUSTOMER_SUCCESS,
//     payload: data,
//     payloadlist: list
// });

// // -------------------- updateMembership --------------------- //
// export const updateChangeStatusMembership = (data, token) => ({
//     type: SETTING_UPDATE_MEMBERSHIP_STATUS,
//     payload: data,
//     token
// });
// export const updateChangeStatusMembershipSuccess = () => ({
//     type: SETTING_UPDATE_MEMBERSHIP_STATUS_SUCCESS,
// });
